import { Navigate, useParams } from 'react-router-dom';

/**
 * /member/in-clinic/:clientId was the legacy in-clinic booking (two static
 * slots, in-house Slot + Appointment, never on Google Calendar). The synced
 * In Centre Visit flow (Google Calendar availability + booking) replaces it.
 */
export const InClinicRedirect = () => {
  const { clientId } = useParams();
  return <Navigate to={`/member/in-center-visit/${clientId ?? ''}`} replace />;
};
